import { Box, BoxProps, Button, Chip, Grid, Stack, Typography } from "@mui/material";
import { useState } from "react";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DialogEditCheque from "../DialogEditDadosCheque";
import { TCheque } from "../../../../../../../../types/api/financeiro/detalhar-cheques";
import { DadosChequeItems } from "../..";

export default function CardDadosCheque({
  boxStyle,
  detalhe,
}: CardDadosChequeProps) {
  const [openEdit, setOpenEdit] = useState(false);

  return (
    <>
      <Box {...boxStyle}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Dados do cheque</Typography>

          <Chip 
          label={detalhe.dadosPagamento.data_baixa ? "Baixado" : "Pendente"} 
          color={detalhe.dadosPagamento.data_baixa ? "success" : "warning"} 
          size="small"
          />
        </Stack>

        <Grid container rowGap={2}>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Publico"
              valor={
                detalhe.dadosCheque.publico
                  ? `${detalhe.dadosCheque.publico.tipo_publico} - ${detalhe.dadosCheque.publico.codigo_publico}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Documento"
              valor={
                detalhe.dadosCheque.documento
                  ? `${detalhe.dadosCheque.documento}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 6}}>
            <DadosChequeItems
              titulo="Banco"
              valor={
                detalhe.dadosCheque.banco
                  ? `${detalhe.dadosCheque.banco.codigo} - ${detalhe.dadosCheque.banco.nome}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 3}}>
            <DadosChequeItems
              titulo="Agencia"
              valor={
                detalhe.dadosCheque.agencia
                  ? `${detalhe.dadosCheque.agencia}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 3}}>
            <DadosChequeItems
              titulo="Digito da agencia"
              valor={
                detalhe.dadosCheque.agencia_digito
                  ? `${detalhe.dadosCheque.agencia_digito}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 3}}>
            <DadosChequeItems
              titulo="Conta"
              valor={
                detalhe.dadosCheque.conta ? `${detalhe.dadosCheque.conta}` : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 3}}>
            <DadosChequeItems
              titulo="Digito da conta"
              valor={
                detalhe.dadosCheque.conta_digito
                  ? `${detalhe.dadosCheque.conta_digito}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 3}}>
            <DadosChequeItems
              titulo="Número do cheque"
              valor={
                detalhe.dadosCheque.numero_cheque
                  ? `${detalhe.dadosCheque.numero_cheque}`
                  : "-"
              }
            />
          </Grid>
          <Grid size={{xs: 12, md: 3}}>
            <DadosChequeItems
              titulo="Sequencial do cheque"
              valor={
                detalhe.dadosCheque.sequencia_cheque
                  ? `${detalhe.dadosCheque.sequencia_cheque}`
                  : "-"
              }
            />
          </Grid>
        </Grid>

        <Stack direction="row" justifyContent="flex-end">
          <Button
            variant="contained"
            size="small"
            startIcon={<EditOutlinedIcon />}
            sx={{ fontSize: "0.75rem" }}
            onClick={() => setOpenEdit(true)}
            disabled={Boolean(detalhe.dadosPagamento.data_baixa)}
          >
            Editar
          </Button>
        </Stack>

        {openEdit && (
          <DialogEditCheque
            open={openEdit}
            handleClose={() => setOpenEdit(false)}
          />
        )}
      </Box>
    </>
  );
}

interface CardDadosChequeProps {
  boxStyle: BoxProps;
  detalhe: TCheque;
}
